// ── ActiveFilterPill — inline pill for active filter controls ─────────────────
import React from 'react';
import { Box, Typography,useTheme } from '@mui/material';
interface ActiveFilterPillProps {
  label: string;
  value: any;
  onRemove: () => void;
  onClick?: () => void;
}

const ActiveFilterPill: React.FC<ActiveFilterPillProps> = ({ label, value, onRemove, onClick }) => {
  const theme = useTheme();
  return (
    <Box
      onClick={onClick}
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: '5px',
        height: 36,
        px: '10px',
        borderRadius: '8px',
        border: `1px solid ${theme.palette.secondary.dark}`,
        bgcolor: `${theme.palette.secondary.dark}12`,
        cursor: onClick ? 'pointer' : 'default',
        transition: 'border-color 0.15s, background 0.15s',
        '&:hover': onClick ? { bgcolor: `${theme.palette.secondary.dark}20` } : {},
      }}
    >
      <Typography sx={{ fontSize: '0.75rem', color: theme.palette.secondary.dark, fontWeight: 600 }}>
        {value}
      </Typography>
      <Box
        component="span"
        onClick={(e) => { e.stopPropagation(); onRemove(); }}
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          width: 16,
          height: 16,
          borderRadius: '50%',
          ml: '2px',
          fontSize: '14px',
          lineHeight: 1,
          color: theme.palette.secondary.dark,
          cursor: 'pointer',
          '&:hover': {
            bgcolor: `${theme.palette.secondary.dark}20`,
            color: theme.palette.secondary.dark,
          },
          transition: 'all 0.15s',
        }}
      >
        ×
      </Box>
    </Box>
  );
};

export default ActiveFilterPill;